<template>
  <div>
    <Header />
    <SearchBar ref="searchBar" :isLandingPage="false"  @clearAndToggleFilter="onClearAndToggleFilter"  @noResultFound="onNoResultFound" @searching="onSearching" />

    <main id="main">
      <div class="container">
        <h4 id="searchQuery" class="h4">
          <div class="loader" v-if="searching">
          <strong>Searching<span class="loader__dot">.</span><span class="loader__dot">.</span><span class="loader__dot">.</span></strong>
        </div>
          <span v-if="resultExist && !searching"> 
            <strong>{{this.showingResultsForText}}</strong>
          </span>
          <span v-if="!resultExist && !searching">{{ noResultMessage }}</span>
        </h4>

        <section id="searchResults" class="row-lg">
          <div
            v-if="facetsExist"
            id="searchResults__filter"
            class="col-lg-auto collapse d-block-lg"
          >
            <form v-on:submit.prevent="search(false, true)">
              <h3 class="sr-only">Filter Search Results</h3>
              <div id="searchResults__filter__actions_top" class="row">
                <div class="col col-lg-12">
                  <button class="btn btn-white btn-block d-none-lg" type="submit">Apply Filters</button>
                  <button
                    class="btn btn-primary btn-block d-none d-block-lg"
                    type="submit"
                  >Apply Filters</button>
                </div>

                <div class="col col-lg-12">
                  <button
                    class="btn btn-primary-dark btn-block d-none-lg"
                    type="button"
                    @click="clear()"
                  >Clear Filters</button>
                  <button
                    class="btn btn-secondary btn-block d-none d-block-lg"
                    type="button"
                    @click="clear()"
                  >Clear Filters</button>
                </div>
              </div>
              <fs title="Province" :model.sync="provinceBuckets" placeHolder="filterProvince" />
              <fs
                title="Service Region"
                :model.sync="serviceRegionBuckets"
                placeHolder="filterRegion"
              />
              <fs
                title="Liability Insurance"
                :model.sync="liabilityInsuranceBuckets"
                placeHolder="filterInsurance"
              />
              <fs
                title="Local Association"
                :model.sync="associationBuckets"
                placeHolder="filterAssociation"
              />
              <div v-if="certifiedInResultExist">
                <fieldset>
                  <legend>
                    <button
                      class="collapseToggle"
                      type="button"
                      data-collapse="filterCertication"
                      aria-expanded="true"
                      aria-controls="filterCertication"
                      @click="toggleCollapse('filterCertication')"
                    >Certifications</button>
                  </legend>

                  <div id="filterCertication" class="collapse collapse--visible show">
                    <div v-if="facets.corCertificationExist" class="checkbox">
                      <input id="filterCertificationCOR" type="checkbox" v-model="corCertified" />
                      <label class ="fs_label" for="filterCertificationCOR">COR Certification</label>
                    </div>
                    <div v-if="facets.wcbCertificationExist" class="checkbox">
                      <input id="filterCertificationWCB" type="checkbox" v-model="wcbCertified" />
                      <label class ="fs_label" for="filterCertificationWCB">{{ wsibName }} Certificate</label>
                    </div>
                    <div v-if="facets.bondableCompanyExist" class="checkbox">
                      <input
                        id="filterCertificationBondable"
                        type="checkbox"
                        v-model="bondableCompany"
                      />
                      <label class ="fs_label" for="filterCertificationBondable">Bondable Company</label>
                    </div>
                  </div>
                </fieldset>
              </div>

              <div id="searchResults__filter__actions" class="row">
                <div class="col col-lg-12">
                  <button class="btn btn-white btn-block d-none-lg" type="submit">Apply Filters</button>
                  <button
                    class="btn btn-primary btn-block d-none d-block-lg"
                    type="submit"
                  >Apply Filters</button>
                </div>

                <div class="col col-lg-12">
                  <button
                    class="btn btn-primary-dark btn-block d-none-lg"
                    type="button"
                    @click="clear()"
                  >Clear Filters</button>
                  <button
                    class="btn btn-secondary btn-block d-none d-block-lg"
                    type="button"
                    @click="clear()"
                  >Clear Filters</button>
                </div>
              </div>
            </form>
          </div>

          <div v-if="resultExist" id="searchResults__results" class="col-lg">
            <h2 class="sr-only">Search Results</h2>

            <div id="searchResults__header">
              <div class="row items-center">
                <div id="searchResults__header__results" class="col-lg">
                  Showing
                  <strong>{{ showingResultText }} </strong> of
                  <strong>{{ pagination.total }} </strong>
                  <span v-if="pagination.total > 1"> results</span>
                  <span v-else>result</span>
                </div>

                <div class="col col-lg-auto">
                  <div class="row-sm">
                    <div class="col d-none-lg">
                      <button
                        class="btn btn-primary btn-block"
                        type="button"
                        data-collapse="searchResults__filter"
                        aria-expanded="false"
                        aria-controls="searchResults__filter"
                        @click="toggleCollapse('searchResults__filter')"
                      >
                        <i class="icomoon icon-filter is-left" aria-hidden="true"></i>Filter
                      </button>
                    </div>

                    <div class="col col-lg-auto">
                      <label class="sr-only" for="searchResultsSort">Sort search results</label>
                      <select
                        id="searchResultsSort"
                        name="searchResultsSort"
                        @change="onSortChange($event)"
                      >
                        <option value disabled selected>Sort by</option>
                        <option value="alpha-asc">Alphabetical (Ascending)</option>
                        <option value="alpha-desc">Alphabetical (Descending)</option>
                      </select>
                    </div>

                    <div class="d-none d-block-sm col-sm-auto">
                      <button
                        id="toggleSearchResults--grid"
                        class="btn btn-white btn-icon btn-toggle"
                        type="button"
                        aria-selected="false"
                        @click="toggleView()"
                      >
                        <i class="icomoon icon-grid" aria-hidden="true"></i> Grid view
                      </button>
                      <button
                        id="toggleSearchResults--list"
                        class="btn btn-white btn-icon btn-toggle"
                        type="button"
                        aria-selected="true"
                        @click="toggleView()"
                      >
                        <i class="icomoon icon-list" aria-hidden="true"></i> List view
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="searchResults__results__listing" class="row searchResults searchResults--list">
              <div v-for="company in sortedCompanies" :key="y=company.id">
                <Company :company="company" />
              </div>
            </div>

            <div id="searchResults__footer">
              <div class="row items-center">
                <div id="searchResults__footer__results" class="col-sm">
                  Showing
                  <strong>{{ showingResultText }} </strong> of
                  <strong>{{ pagination.total }} </strong>
                  <span v-if="pagination.total > 1"> results</span>
                  <span v-else>result</span>
                </div>

                <div class="col-auto">
                  <div class="row-sm">
                    <div class="col-auto">
                      <div class="inputGroup">
                        <button
                          class="btn btn-white btn-icon"
                          type="button"
                          v-if="pagination.page != 1"
                          @click="previous()"
                        >
                          <i class="icomoon icon-chevron-left" aria-hidden="true"></i>Previous page
                        </button>
                        <label class="sr-only" for="searchResultsPage">Page select</label>
                        <select
                          id="searchResultsPage"
                          name="searchResultsPageSelect"
                          v-model="pagination.page"
                          @change="jumpToPage"
                        >
                          <option
                            v-for="option in numberOfPagesOptions"
                            :key="option.value"
                            :value="option.value"
                          >{{option.text}}</option>
                        </select>
                        <button
                          class="btn btn-white btn-icon"
                          type="button"
                          v-if="pagination.page < numberOfPages"
                          @click="next()"
                        >
                          <i class="icomoon icon-chevron-right" aria-hidden="true"></i>Next page
                        </button>
                      </div>
                    </div>

                    <div class="col-auto">
                      <label class="sr-only" for="searchResultsPaged">Results per page</label>
                      <select
                        id="searchResultsPaged"
                        name="searchResultsPaged"
                        v-model="pagination.perPage"
                        @change="jumpToPageSize"
                      >
                        <option
                          v-for="option in pageSizeOptions"
                          :key="option.value"
                          :value="option.value"
                        >{{option.text}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>
<script>
import Company from "@/components/company.vue";
import Header from "@/components/header.vue";
import SearchBar from "@/components/search-bar.vue";
import fs from "@/components/fieldset.vue";
import { mapState } from "vuex";
import orderBy from "lodash/orderBy";

export default {
  name: "SearchResults",
  components: { Company, Header, SearchBar, fs },
  data: function() {
    return {
      noResultMessage: process.env.VUE_APP_STATIC_NORESULT_MESSAGE,
      showingResultsForText: null,
      searching:false,
      sortedCompanies: [],
      liabilityInsuranceBuckets: [],
      serviceRegionBuckets: [],
      corCertified: false,
      wcbCertified: false,
      bondableCompany: false,
      unionAffiliated: false,
      provinceBuckets: [],
      associationBuckets: []
    };
  },
  async created() {
    if (this.companies) {
      this.sortedCompanies = this.companies;
    }
    if (this.searchCrieteria) {
      this.onNoResultFound(false);
      this.corCertified = this.searchCrieteria.corCertified;
      this.wcbCertified = this.searchCrieteria.wcbCertified;
      this.bondableCompany = this.searchCrieteria.bondableCompany;
      this.unionAffiliated = this.searchCrieteria.unionAffiliated;
      this.provinceBuckets = this.searchCrieteria.provinceBuckets;
      this.liabilityInsuranceBuckets = this.searchCrieteria.liabilityInsuranceBuckets;
      this.serviceRegionBuckets = this.searchCrieteria.serviceRegionBuckets;
      this.associationBuckets = this.searchCrieteria.associationBuckets;
    }
  },
  computed: {
    ...mapState(["companies", "facets", "pagination", "searchCrieteria"]),
    wsibName(){
     return process.env.VUE_APP_TENANT_NAME.toLowerCase() === 'link2build' ? 'WSIB' : 'WCB'
    },
    numberOfPages() {
      return Math.ceil(this.pagination.total / this.pagination.perPage);
    },
    numberOfPagesOptions() {
      let arr = [];
      for (var i = 1; i <= this.numberOfPages; i++) {
        arr.push({
          text: `${i} of ${this.numberOfPages}`,
          value: i
        });
      }
      return arr;
    },
    pageSizeOptions() {
      let arr = [];
      arr.push({
        text: `${process.env.VUE_APP_STATIC_PAGINATION_PER_PAGE}/Page`,
        value: process.env.VUE_APP_STATIC_PAGINATION_PER_PAGE
      });
      arr.push({
        text: `50/Page`,
        value: 50
      });
      
      return arr;
    },
    showingResultText() {
      let from = this.pagination.perPage * (this.pagination.page - 1) + 1;
      let to = this.pagination.perPage * this.pagination.page;
      if (to > this.pagination.total) {
        to = this.pagination.total;
      }
      if (from === to) {
        return `${from}`;
      }
      return `${from}-${to}`;
    },
    certifiedInResultExist() {
      return (
        this.facets.corCertificationExist ||
        this.facets.wcbCertificationExist ||
        this.facets.bondableCompanyExist ||
        this.facets.unionAffiliationExist
      );
    },
    resultExist() {
      return this.companies && this.companies.length > 0;
    },
    facetsExist() {
      return (
        this.facets && 
        (this.facets.provinces ||
        this.facets.liabilityInsurance ||
        this.facets.associations ||
        this.facets.serviceRegions ||
        this.certifiedInResultExist)
      );
    }
  },
  watch: {
    companies() {
      this.sortedCompanies = this.companies;
    }
  },
  mounted() {
    this.$nextTick(function() {
      document.body.classList.add("search");
      window.addEventListener("resize", this.filterRepositioning);
      //Init
      this.filterRepositioning();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.filterRepositioning);
  },
  destroyed() {
    document.body.classList.remove("search");
  },

  methods: {
    search(getFacets, setPagination) {
      this.toggleCollapse('searchResults__filter');
      let query = "";

      query += this.corCertified ? `corCertified=true&` : "";
      query += this.wcbCertified ? `wcbCertified=true&` : "";
      query += this.bondableCompany ? `bondableCompany=true&` : "";
      query += this.unionAffiliated ? `unionAffiliated=true&` : "";
      query +=
        this.provinceBuckets.length === 0
          ? ""
          : `${this.arrayParams(this.provinceBuckets, "provinces")}&`;
      query +=
        this.serviceRegionBuckets.length === 0
          ? ""
          : `${this.arrayParams(this.serviceRegionBuckets, "serviceRegions")}&`;
      query +=
        this.liabilityInsuranceBuckets.length === 0
          ? ""
          : `${this.arrayParams(
              this.liabilityInsuranceBuckets,
              "liabilityInsurances"
            )}&`;
      query +=
        this.associationBuckets.length === 0
          ? ""
          : `${this.arrayParams(this.associationBuckets, "associations")}&`;

      this.$refs.searchBar.filterQuery = query;
      this.$refs.searchBar.criteria = {
        corCertified: this.corCertified,
        wcbCertified: this.wcbCertified,
        bondableCompany: this.bondableCompany,
        unionAffiliated: this.unionAffiliated,
        provinceBuckets: this.provinceBuckets,
        liabilityInsuranceBuckets: this.liabilityInsuranceBuckets,
        serviceRegionBuckets: this.serviceRegionBuckets,
        associationBuckets: this.associationBuckets
      };

      this.$refs.searchBar.search(getFacets, setPagination);
    },
    arrayParams(array, paramName) {
      let params = array.map(v => {
        return `${paramName}=${v}&`;
      });
      return params.join("").slice(0, -1);
    },
    clear() {
      this.corCertified = false;
      this.wcbCertified = false;
      this.bondableCompany = false;
      this.unionAffiliated = false;
      this.provinceBuckets = [];
      this.serviceRegionBuckets = [];
      this.liabilityInsuranceBuckets = [];
      this.associationBuckets = [];
    },
    previous() {
      this.pagination.page--;
      this.search(false, false);
    },
    next() {
      this.pagination.page++;
      this.search(false, false);
    },
    toggleCollapse(collapseId) {
      var collapse = event.srcElement;
      if(document.getElementById(collapseId)){
        document.getElementById(collapseId).classList.toggle("collapse--visible");
      }
       
      if (
        document.getElementById(collapseId) &&
          document.getElementById(collapseId).classList.contains("collapse--visible")
      ) {
        collapse.setAttribute("aria-expanded", "true");
        document.getElementById(collapseId).classList.add("show");
      } else {
        collapse.setAttribute("aria-expanded", "false");
      }
      if (event.srcElement.hasAttribute("data-collapse-remove")) {
        event.srcElement.parentNode.removeChild(event.srcElement);
      }
    },
    toggleView() {
      let searchResultsListing = document.getElementById(
        "searchResults__results__listing"
      );
      let toggleSearchResultsGrid = document.getElementById(
        "toggleSearchResults--grid"
      );
      let toggleSearchResultsList = document.getElementById(
        "toggleSearchResults--list"
      );

      // Grid view
      if (
        event.srcElement === toggleSearchResultsGrid ||
        event.srcElement.parentElement === toggleSearchResultsGrid
      ) {
        toggleSearchResultsGrid.setAttribute("aria-selected", "true");
        toggleSearchResultsList.setAttribute("aria-selected", "false");

        searchResultsListing.classList.remove("searchResults--list");
        searchResultsListing.classList.add("searchResults--grid");
      }

      // List view
      if (
        event.srcElement === toggleSearchResultsList ||
        event.srcElement.parentElement === toggleSearchResultsList
      ) {
        toggleSearchResultsGrid.setAttribute("aria-selected", "false");
        toggleSearchResultsList.setAttribute("aria-selected", "true");

        searchResultsListing.classList.remove("searchResults--grid");
        searchResultsListing.classList.add("searchResults--list");
      }
    },
    filterRepositioning() {
      let searchResults = document.getElementById("searchResults");
      let searchResultsHeader = document.getElementById(
        "searchResults__header"
      );
      let searchFilter = document.getElementById("searchResults__filter");
      if (searchFilter) {
        if (window.matchMedia("(min-width: 70.857142857rem)").matches) {
          searchResults.insertBefore(searchFilter, searchResults.firstChild);
        } else {
          searchResultsHeader.appendChild(searchFilter);
        }
      }
    },
    onSortChange(event) {
      switch (event.target.value) {
        case "alpha-asc":
          this.sortedCompanies = orderBy(this.companies, c =>
            c.name.toLowerCase()
          );
          break;
        case "alpha-desc":
          this.sortedCompanies = orderBy(
            this.companies,
            c => c.name.toLowerCase(),
            ["desc"]
          );
          break;
        default:
          this.sortedCompanies = this.companies;
      }
    },
    jumpToPage() {
      this.pagination.page = event.target.value;
      this.search(false, false);
    },
    jumpToPageSize() {
      this.pagination.perPage = event.target.value;
      this.pagination.page = 1;
      this.search(false, false);
    },
    onClearAndToggleFilter(){
      this.toggleCollapse('searchResults__filter');
      this.corCertified = false;
      this.wcbCertified = false;
      this.bondableCompany = false;
      this.unionAffiliated = false;
      this.provinceBuckets = [];
      this.liabilityInsuranceBuckets = [];
      this.serviceRegionBuckets = [];
      this.associationBuckets = [];
    },
    onNoResultFound(value){
      if(!value){ 
        let messageBody = "";
        if(this.searchCrieteria.keyword && this.searchCrieteria.keyword.length > 0 && this.searchCrieteria.location && this.searchCrieteria.location.length > 0)
          messageBody = `${this.searchCrieteria.keyword}, ${this.searchCrieteria.location}`;
        else
          messageBody = `${this.searchCrieteria.keyword}${this.searchCrieteria.location}`;
        
        this.showingResultsForText = messageBody && messageBody.length > 0 ? `Results for: ${messageBody}`: "Search Result";   
        
      }
    },
    onSearching(value){
      this.searching = value;
    }
  }
};
</script>